import script from "./FranchiseLocationsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseLocationsPanel.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseLocationsPanel.vue?vue&type=style&index=0&id=dc10565a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc10565a"]])

export default __exports__